import { useEffect } from 'react';
import { useStateInRef } from 'seagull';
import { useBusinessChannelEventBinder } from './useBusinessChannelEventBinder';
export function useBusinessChannelEvent(params) {
    const { eventName, source } = params;
    const { startListening } = useBusinessChannelEventBinder(eventName, source);
    const getParams = useStateInRef(params);
    useEffect(()=>{
        startListening((event)=>getParams().callback(event), {
            onBind: ()=>{
                var _getParams_onBind, _getParams;
                return (_getParams_onBind = (_getParams = getParams()).onBind) === null || _getParams_onBind === void 0 ? void 0 : _getParams_onBind.call(_getParams);
            }
        });
    }, [
        eventName
    ]);
}
